export default __webpack_public_path__ + "static/media/SOL.74468981.png";